var bt_visual = new Swiper(".bt_visual .mySwiper", {
    effect:'fade',
    speed:800,
    loop:true,
    autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


/* 뷰티테크 디바이스 슬라이드 */
var device_slide = new Swiper(".lineup_slide.swiper", {
slidesPerView: 1.5,
spaceBetween: 20,
grabCursor: true,
loop: true,
speed: 800,

autoplay: {
delay: 2500,
disableOnInteraction: false,
},
breakpoints: {
600: {
  slidesPerView: "auto",
  loop: true,
  speed: 800,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
},
},
});

var swiperOptions = {
loop: true,
spaceBetween: 12,
autoplay: {
delay: 0,
disableOnInteraction: false
},

slidesPerView: 'auto',
speed: 4000,
breakpoints: {
600: {
spaceBetween:20,

},
}
};
var awward_slide = new Swiper(".awward_slide.swiper-container", swiperOptions);


gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

//scroll txt fade out
const txtFadeOut = (param) => {
const tl = gsap.timeline({
scrollTrigger: {
  trigger: param,
  start: "60% bottom",
  end: "60% top",
  scrub: true,
},
});
tl.to(param, {
opacity: 1,
});
tl.to(param, {
opacity: 0,
});
};

//txt scroll effect1
gsap.utils.toArray("div[class ^= bt_intro_txt]").forEach(function (param) {
ScrollTrigger.create({
trigger: param,
onEnter: function () {
  txtFadeOut(param);
},
});
});

/* fadeUp txt 효과 */
gsap.to(".sc_ton .device_info", {
scrollTrigger: {
trigger: ".sc_ton",
start: "top 45%",
toggleClass: { targets: ".sc_ton .device_info", className: "fade_up" },
},
});
gsap.to(".sc_line .device_info", {
    scrollTrigger: {
    trigger: ".sc_line",
    start: "top 45%",
    toggleClass: { targets: ".sc_line .device_info", className: "fade_up" },
    },
});
gsap.to(".sc_body .device_info", {
    scrollTrigger: {
    trigger: ".sc_body",
    start: "top 45%",
    toggleClass: { targets: ".sc_body .device_info", className: "fade_up" },
    },
});
gsap.to(".sc_bst .device_info", {
scrollTrigger: {
trigger: ".sc_bst",
start: "top 45%",
toggleClass: { targets: ".sc_bst .device_info", className: "fade_up" },
},
});
gsap.to(".sc_hz .device_info", {
scrollTrigger: {
trigger: ".sc_hz",
start: "top 55%",
toggleClass: { targets: ".sc_hz .device_info", className: "fade_up" },
},
});
//pc - 글로우 포레이션

mm.add("(min-width: 1024px)", () => {
gsap.to(".sc_bst .device_intro .device_img", {
scrollTrigger: {
  trigger: ".sc_bst",
  start: "top 10%",
  toggleClass: {
    targets: ".sc_bst .device_intro .device_img",
    className: "on",
  },
},
});
});

//mo - 글로우 포레이션
mm.add("(max-width: 1024px)", () => {
gsap.to(".sc_bst .device_intro .device_img", {
scrollTrigger: {
  trigger: ".sc_bst",
  start: "top 40%",
  toggleClass: {
    targets: ".sc_bst .device_intro .device_img",
    className: "on",
  },
},
});
});

// count up - 글로우 포레이션
gsap.to(".bst_up_num", {
scrollTrigger: {
trigger: ".sc_bst .device_intro",
onEnter: cntUp,
start: "top 20%",
},
duration: 10,
});
function cntUp() {
$(".bst_up_num").each(function () {
var $this = $(this),
  countTo = $this.attr("data-count");
$({ countNum: $this.text() }).animate(
  {
    countNum: countTo,
  },
  {
    duration: 800,
    easing: "linear",
    step: function () {
      $this.text(Math.floor(this.countNum));
    },
    complete: function () {
      $this.text(this.countNum);
    },
  }
);
});
}
// count up - 누적임상연구
gsap.to(".lab_cnt_up", {
scrollTrigger: {
trigger: ".sc_skinlab .skinlab_box.sec",
onEnter: labCntUp,
start: "top 70%",
},
duration: 3,
});
function labCntUp() {
$(".lab_cnt_up").each(function () {
var $this = $(this),
  countTo = $this.attr("data-count");
$({ countNum: $this.text() }).animate(
  {
    countNum: countTo,
  },
  {
    duration: 800,
    easing: "linear",
    step: function () {
      $this.text(Math.floor(this.countNum));
    },
    complete: function () {
      $this.text(this.countNum);
    },
  }
);
});
}
mm.add("(min-width: 767px)", () => {
gsap.to(".skinlab_bg", {
scrollTrigger: {
  trigger: ".sc_skinlab",
  pin: ".skinlab_bg",
  start: "top top",
  end: "bottom bottom",
},
});
});
mm.add("(max-width: 767px)", () => {
gsap.to(".skinlab_bg", {
scrollTrigger: {
  trigger: ".sc_skinlab",
  pin: ".skinlab_bg",
  start: "top 20%",
  end: "bottom 110%",
},
});
});
//txt scroll effect2
gsap.utils.toArray(".skinlab_box").forEach(function (param) {
ScrollTrigger.create({
trigger: param,
onEnter: function () {
  txtFadeOut(param);
},
});
});

gsap.fromTo(
".skinlab_bg .skinlab_opac",
{
opacity: 0,
},
{
scrollTrigger: {
  trigger: ".sc_skinlab",
  start: "top 20%",
  end: "bottom -20%",
  scrub: 1,
},
opacity: 1,
}
);

//토닝 포레이션 타사 비교 영역
/*
mm.add("(min-width: 1024px)", () => {
gsap.to(".sc_ton .device_img", {
scrollTrigger: {
  trigger: ".sc_ton",
  pin: ".sc_ton .device_img",
  start: "top top",
  end: "bottom bottom",
},
});
});
*/
mm.add("(min-width: 767px)", () => {
gsap.to(".sc_shot .device_info", {
scrollTrigger: {
  trigger: ".sc_shot .shot_point.fis",
  start: "top 70%",
  toggleClass: { targets: ".sc_shot .shot_point", className: "show" },
},
});
});

mm.add("(max-width: 767px)", () => {
gsap.to(".sc_shot .device_info", {
scrollTrigger: {
  trigger: ".sc_shot .shot_point.fis",
  start: "top 50%",
  toggleClass: { targets: ".sc_shot .shot_point", className: "show" },
},
});
});

gsap.to(".sc_shot .device_info", {
scrollTrigger: {
trigger: ".sc_shot",
start: "top 45%",
toggleClass: { targets: ".sc_shot .device_info", className: "fade_up" },
},
});

/* ager app bg color */
mm.add("(min-width: 767px)", () => {
gsap.to(".sc_ager_app", {
scrollTrigger: {
  trigger: ".sc_ager_app",
  start: "top 35%",
  toggleClass: { targets: ".sc_ager_app", className: "bg_ch" },
},
});
});
mm.add("(max-width: 767px)", () => {
gsap.to(".sc_ager_app", {
scrollTrigger: {
  trigger: ".sc_ager_app",
  start: "top 60%",
  toggleClass: { targets: ".sc_ager_app", className: "bg_ch" },
},
});
});

/* ager app slide */
var ager_slide = new Swiper(".ager_slide", {
centeredSlides: true,
loop: true,
slidesPerView: "auto",
speed: 700,
autoplay: {
delay: 3000,
disableOnInteraction: false,
},
navigation: {
nextEl: ".swiper-button-next",
prevEl: ".swiper-button-prev",
},
});
